import React, { useState, useEffect } from "react";
import i18n from "i18next";

import { Button, Checkbox, Divider } from "@fluentui/react-components";
import { IAuswahlTeamMemberDto } from "../../Models/IAuswahlTeamMemberDto";
import { ChevronDownRegular, ChevronUpRegular } from "@fluentui/react-icons";
import { IAuswahlTeamDto } from "../../Models/IAuswahlTeamDto";

interface ITeamMemberSelectionProps {
  team: IAuswahlTeamDto;
  selectionChanged: any;
}

function TeamMemberSelection(props: ITeamMemberSelectionProps) {
  const [showMembers, setShowMembers] = useState<boolean>(false);
  const [team, setTeam] = useState(props.team);
  const handleTeamValuesChange = (name: string, val: any) => {
    setTeam((prevState: any) => ({
      ...prevState,
      [name]: val,
    }));
  };

  useEffect(() => {
    props.selectionChanged(team);
  }, [team]);

  const onChangeSelectionOfMember = (updatedMember: any) => {
    const updatedMembers = team.members.map((member: any) => {
      if (updatedMember.memberGuid == member.memberGuid) {
        return updatedMember;
      } else {
        return member;
      }
    });
    handleTeamValuesChange("members", updatedMembers);
  };

  const onChangeSelectionOfTeam = (isSelected: any) => {
    const updatedMembers = team.members.map((member: any) => {
      member.isSelected = isSelected;
      return member;
    });
    handleTeamValuesChange("members", updatedMembers);
    handleTeamValuesChange("isSelected", isSelected);
  };
  useEffect(() => {
    if (team.members.some((x) => x.isSelected == true)) {
      setShowMembers(true);
    }
    {
    }
  }, []);
  return (
    <div>
      <Checkbox
        style={{ fontWeight: "800", color: "black" }}
        label={props.team.teamname}
        checked={team.isSelected}
        onChange={(ev, val) => {
          if (val.checked != "mixed") {
            onChangeSelectionOfTeam(val.checked);
          }
        }}
      />
      {team.members.length > 0 && (
        <Button
          appearance="transparent"
          icon={showMembers ? <ChevronUpRegular /> : <ChevronDownRegular />}
          onClick={() => {
            if (showMembers == false) {
              setShowMembers(true);
            } else setShowMembers(false);
          }}
        />
      )}
      <div style={{ display: "flex", flexDirection: "column" }}>
        {showMembers &&
          team.members.map((member: IAuswahlTeamMemberDto) => {
            return (
              <Checkbox
                disabled={team.isSelected}
                className="lueb-MarginLeft20"
                label={member.vorname + " " + member.name}
                checked={member.isSelected}
                onChange={(ev, val) => {
                  if (val.checked != "mixed") {
                    member.isSelected = val.checked;
                  }
                  onChangeSelectionOfMember(member);
                }}
              />
            );
          })}
      </div>
    </div>
  );
}

export default TeamMemberSelection;
